export const getAssetWithOverrideMobileLocation = (
  asset,
  { mobile_warehouse_location, warehouse_location, warehouse_locations, warehouse }
) => {
  const isMobileWarehouseLocationChanged = typeof mobile_warehouse_location !== "undefined";
  const hasWarehouseLocationChange = warehouse_location || warehouse_locations;
  if (!isMobileWarehouseLocationChanged && !hasWarehouseLocationChange && !warehouse) {
    return asset;
  }

  return {
    ...asset,
    rackLocations: asset?.rackLocations?.map(location => {
      const item = { ...location };

      if (isMobileWarehouseLocationChanged) {
        item.mobile_warehouse_location = mobile_warehouse_location;
      }
      if (warehouse_locations) {
        item.warehouse_locations = warehouse_locations;
      } else if (warehouse_location) {
        item.warehouse_locations = [warehouse_location];
      }
      if (warehouse) {
        item.warehouse = warehouse;
      }

      return item;
    }),
  };
};
